import { Injectable, OnDestroy } from '@angular/core';
import { deepCopy } from '@common/helpers';
import { updateStateBookingList } from '@common/store/booking-list/booking-list.actions';
import { bookingListInitialState } from '@common/store/booking-list/booking-list.reducer';
import { getDataBookingList } from '@common/store/booking-list/booking-list.selector';
import { BookingListState } from '@common/store/booking-list/booking-list.state';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class BookingListStoreService implements OnDestroy {
  private storeCurrentValueSubscription!: Subscription;
  private storeCurrentValue = bookingListInitialState;

  constructor(private store: Store) {
    this.storeCurrentValueSubscription = this.store.select(getDataBookingList).subscribe((val) => {
      this.storeCurrentValue = val ?? bookingListInitialState;
    });
  }

  getBookingListStore() {
    return this.storeCurrentValue;
  }

  updateBookingList(value: BookingListState) {
    this.store.dispatch(updateStateBookingList({ ...deepCopy(this.storeCurrentValue), ...value }));
  }

  ngOnDestroy() {
    this.storeCurrentValueSubscription.unsubscribe();
  }
}
